import NBType, { InferType } from '@netbase/nb-type'
import MetricSchema from './MetricSchema'
import TimelineAnnotationGroupSchema from './TimelineAnnotationGroupSchema'

const AnnotatedMetricResultSchema = NBType.object().shape('AnnotatedMetricResultSchema', {
  /* @prop */
  endDate: NBType.timestamp(),
  /* @prop */
  errorCode: NBType.number(),
  /* @prop */
  errorParams: NBType.array().of(NBType.string()),
  /* @prop */
  metrics: NBType.array(MetricSchema),
  /* @prop */
  startDate: NBType.timestamp(),
  /* @prop */
  timelineNoteGroups: NBType.array(TimelineAnnotationGroupSchema)
  /* END */
})
export default AnnotatedMetricResultSchema
export type AnnotatedMetricResult = InferType<typeof AnnotatedMetricResultSchema>
// RESERVE BELOW
export type AnnotatedMetricResultWith<T = typeof MetricSchema> = Omit<
  AnnotatedMetricResult,
  'metrics'
> & {
  metrics: T[]
}
